// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"ab82a454","453":"69c86cd4"}[chunkId] + ".chunk.js";
};